export default "__VITE_ASSET__DTOO0Qhr__"